import { render, staticRenderFns } from "./rental.vue?vue&type=template&id=12dde31b&scoped=true&"
import script from "./rental.vue?vue&type=script&lang=js&"
export * from "./rental.vue?vue&type=script&lang=js&"
import style0 from "./rental.vue?vue&type=style&index=0&id=12dde31b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12dde31b",
  null
  
)

export default component.exports